import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { find } from 'lodash';

import useActions from './useActions';
import { fetchSeries, setCurrentSerie, cleanQuestion } from 'actions';

const useSeries = id => {
  const dispatchFetchSeries = useActions(fetchSeries);
  const dispatchSetCurrentSerie = useActions(setCurrentSerie);
  const dispatchCleanQuestion = useActions(cleanQuestion);

  dispatchSetCurrentSerie(id);
  if (!id)
    dispatchCleanQuestion();

  const series = useSelector(
    ({ serie }) => serie.series,
  );

  const memoizedFetch = useCallback(() => dispatchFetchSeries({onSuccess: () => console.log("yooo")}),
    [dispatchFetchSeries],
  );

  useEffect(() => {
    memoizedFetch();
  }, [memoizedFetch]);

  if (typeof id === 'number') {
    return find(series, s => s.id === id);
  }

  return series;
};

export default useSeries;
